<template>
    <v-popover :open="openPopover" @apply-show="onPopoverShow">
        <slot name="text">
            <div @mouseover="isHoveredText = true"
                 @mouseleave="isHoveredText = false"
                 @click="openPopover = true"
                 class="clickable">
                {{ value }}
                <span v-show="isHoveredText"
                      class="text-primary-light font-14">
                    <i class="fal fa-pencil"></i>
                </span>
            </div>
        </slot>

        <template slot="popover">
            <slot name="popover-header" :value="text"></slot>

            <input
                class="form-control form-control-sm"
                id="popover-editable-text-input"
                v-model="text"
                :disabled="disabled"
                @keyup.enter="onSave"
                placeholder="Enter a value"/>

            <!-- usually for validation message -->
            <slot name="popover-footer" :value="text"></slot>

            <slot name="popover-actions" :value="text">
                <div class="mt-3 text-right">
                    <button @click="openPopover = false"
                            class="btn btn-sm btn-link text-info d-inline-block">
                        Cancel
                    </button>
                    <button @click="onSave" class="btn btn-sm btn-outline-primary d-inline-block">
                        Save
                    </button>
                </div>
            </slot>
        </template>
    </v-popover>
</template>

<script>
export default {
    name: 'AppEditableText',
    props: {
        value: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            text: '',
            isHoveredText: false,
            openPopover: false
        }
    },
    methods: {
        onSave() {
            this.$emit('update', this.text)
            this.openPopover = false
        },

        onPopoverShow() {
            this.text = this.value
            this.focusInput()
        },

        focusInput() {
            setTimeout(() => {
                const inputEl = document.getElementById('popover-editable-text-input')
                if (inputEl) {
                    inputEl.focus()
                }
            }, 100)
        }
    }
}
</script>
